import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { DUMMY_ORDER } from "../OrderConfirmation/lib";
import {
  Actions,
  type CreateCommentSuccessActionData,
  type InitSuccessActionData,
  type SetAddCommentModalVisibleActionData
} from "./actions";
import { type OrderDetail } from "./types";

const reducer = (state: OrderDetail.AppState = defaultState, action: ReduxAction<any>): OrderDetail.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { history, orderSummary } = action.data as InitSuccessActionData;
      return {
        ...state,
        history,
        orderSummary,
        status: Status.Ready
      };
    }

    case Actions.DownloadInvoiceBegin: {
      return {
        ...state,
        status: "Downloading"
      };
    }
    case Actions.DownloadInvoiceFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.DownloadInvoiceSuccess: {
      return {
        ...state,
        status: "Ready"
      };
    }

    case Actions.CreateCommentBegin: {
      return {
        ...state,
        status: "Creating"
      };
    }
    case Actions.CreateCommentFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.CreateCommentSuccess: {
      const { history } = action.data as CreateCommentSuccessActionData;

      return {
        ...state,
        orderSummary: { ...state.orderSummary!, history: history },
        status: "Ready"
      };
    }

    case Actions.SetAddCommentModalVisible: {
      const { isVisible } = action.data as SetAddCommentModalVisibleActionData;

      return {
        ...state,
        isAddCommentVisible: isVisible
      };
    }

    default:
      return state;
  }
};

export const defaultState: OrderDetail.AppState = {
  error: null,
  id: "",
  history: [],
  orderSummary: null,
  status: Status.None,
  isAddCommentVisible: false
};
export const previewState: OrderDetail.AppState = {
  ...defaultState,
  orderSummary: DUMMY_ORDER,
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
